import React from 'react';
import { Navigate } from 'react-router-dom';
import CFTSidebar from './CFTSidebar';
import { useAuth } from '../../../context/AuthContext';
import UserMenu from '../../../components/UserMenu';
import AnnouncementBanner from '../../../components/announcements/AnnouncementBanner';

const CFTLayout = ({ children }) => {
  const { currentUser, isAuthenticated } = useAuth();

  // Redirect if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Only allow internal users to access the admin control center
  if (!currentUser || currentUser.userType === 'client') {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-400 mb-4">Access Denied</h1>
          <p className="text-slate-400">This admin control center is only accessible to internal users.</p>
        </div>
      </div>
    );
  }

  return (
      <div className="flex flex-col lg:flex-row min-h-screen bg-slate-900">
        <CFTSidebar />
        <div className="flex-1 w-full lg:w-auto lg:ml-64">
          <header className="bg-slate-800 border-slate-700 border-b sticky top-0 z-30">
            <div className="px-6 py-4 flex justify-between items-center">
              <h1 className="text-xl font-semibold text-slate-200 ml-12 lg:ml-0 min-w-0 truncate">
                KSP | Client Portal Management
              </h1>
              <AnnouncementBanner />
              <div className="flex-shrink-0">
                <UserMenu isDarkMode={true} />
              </div>
            </div>
        </header>
        <main className="p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default CFTLayout;